import React from 'react'
import { useCampaigns } from '../../contexts/CampaignsContext'
import { usePagination } from '../../hooks/usePagination'
import Pagination from '../Pagination'

const AccountDataSection = () => {
  const {
    selectedAccount,
    loading,
    getPlataformColor,
    formatCurrency,
    formatNumber,
    formatDateOnly
  } = useCampaigns()

  const campaigns = selectedAccount?.campaigns || []
  const {
    paginatedData: paginatedCampaigns,
    currentPage,
    totalPages,
    totalItems,
    goToPage
  } = usePagination(campaigns, 5, true)

  if (loading) {
    return (
      <div className='flex justify-center items-center h-64'>
        <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600'></div>
      </div>
    )
  }

  return (
    <section className='flex flex-col gap-10 p-5 border border-gray-200 rounded-lg bg-gray-50/50'>
      <div className='space-y-1'>
        <span className='text-gray-400'>Cliente</span>
        <p className='text-xl font-semibold'>{selectedAccount.client_name || 'Sin definir'}</p>
      </div>

      <div className='space-y-1'>
        <span className='text-gray-400'>Cuenta</span>
        <p className='text-xl font-semibold'>{selectedAccount.account_name || 'Sin definir'}</p>
      </div>

      <div className='space-y-1'>
        <span className='text-gray-400'>Plataforma</span>
        <p
          className={`${getPlataformColor(
            selectedAccount.platform
          )} w-fit px-3 py-1 rounded-full text-xl font-semibold`}
        >
          {selectedAccount.platform}
        </p>
      </div>

      {/* Datos de cada campaign */}
      <div className='overflow-x-auto rounded-lg border border-gray-200'>
        <div className='rounded-lg'>
          <table className='min-w-full divide-y divide-gray-200'>
            <thead className='bg-gray-50 text-center'>
              <tr>
                <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                  Nombre de Campaña
                </th>
                <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                  Activo
                </th>
                <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                  Alcance
                </th>
                <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                  Frecuencia
                </th>
                <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                  Costo por Resultado
                </th>
                <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                  Importe Gastado
                </th>
                <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                  CTR
                </th>
                <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                  Presupuesto
                </th>
                <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                  Fecha de Creación
                </th>
                <th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                  Fecha de Última Modificación
                </th>
              </tr>
            </thead>
            <tbody className='bg-white divide-y divide-gray-200'>
              {paginatedCampaigns.map((metric, index) => (
                <tr key={metric.id || index} className='hover:bg-gray-50 h-16 text-center'>
                  <td className='px-4 py-4 whitespace-nowrap text-sm text-left text-gray-900 max-w-80 overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none]'>
                    {metric.campaign_name || ''}
                  </td>
                  <td className='px-4 py-4 whitespace-nowrap text-sm text-gray-900'>
                    {metric.active !== undefined ? (metric.active ? 'Sí' : 'No') : ''}
                  </td>
                  <td className='px-4 py-4 whitespace-nowrap text-sm text-gray-900'>
                    {metric.reach !== undefined ? formatNumber(metric.reach) : ''}
                  </td>
                  <td className='px-4 py-4 whitespace-nowrap text-sm text-gray-900'>
                    {metric.frequency !== undefined ? metric.frequency.toFixed(2) : ''}
                  </td>
                  <td className='px-4 py-4 whitespace-nowrap text-sm text-gray-900'>
                    {metric.cost_per_result !== undefined
                      ? formatCurrency(metric.cost_per_result)
                      : ''}
                  </td>
                  <td className='px-4 py-4 whitespace-nowrap text-sm text-gray-900'>
                    {metric.cost_micros !== undefined
                      ? formatCurrency(metric.cost_micros / 1000000)
                      : ''}
                  </td>
                  <td className='px-4 py-4 whitespace-nowrap text-sm text-gray-900'>
                    {metric.ctr !== undefined ? metric.ctr.toFixed(2) + '%' : ''}
                  </td>
                  <td className='px-4 py-4 whitespace-nowrap text-sm text-gray-900'>
                    {metric.budget !== undefined ? formatCurrency(metric.budget) : ''}
                  </td>
                  <td className='px-4 py-4 whitespace-nowrap text-sm text-gray-900'>
                    {metric.created_at ? formatDateOnly(metric.created_at) : ''}
                  </td>
                  <td className='px-4 py-4 whitespace-nowrap text-sm text-gray-900'>
                    {metric.updated_at ? formatDateOnly(metric.updated_at) : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Paginación para campañas */}
      {totalItems > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={goToPage}
          itemsPerPage={10}
          totalItems={totalItems}
        />
      )}
    </section>
  )
}

export default AccountDataSection
